import { create } from 'zustand';
import { AUDIO } from '@config/constants';

export type SynthType = 'pluck' | 'karplus' | 'sine';

interface AudioState {
  initialized: boolean;
  volume: number;
  synth: SynthType;
  latencyMs: number;

  setInitialized: (v: boolean) => void;
  setVolume: (v: number) => void;
  setSynth: (t: SynthType) => void;
  setLatency: (ms: number) => void;
}

const clamp = (v: number, min: number, max: number) =>
  Math.max(min, Math.min(max, v));

export const useAudioStore = create<AudioState>((set) => ({
  initialized: false,
  volume: AUDIO.VOLUME.DEFAULT,
  synth: 'pluck',
  latencyMs: 0,

  setInitialized: (initialized) => set({ initialized }),
  setVolume: (volume) => set({ volume: clamp(volume, AUDIO.VOLUME.MIN, AUDIO.VOLUME.MAX) }),
  setSynth: (synth) => set({ synth }),
  setLatency: (latencyMs) => set({ latencyMs }),
}));
